import React, { Fragment } from "react";
import moment from "moment";
import { Link, useNavigate } from "react-router-dom";
import { Typography } from "@mui/material";
import { Button, Dropdown } from "react-bootstrap";
import { toast } from "react-toastify";
import axios from "axios";
import { confirmAlert } from "react-confirm-alert";

import IssueTicket from "./IssueTicket";
import BookingDetail from "./BookingDetail";
import customTime from "../../../utils/customTime";
import CheckTTL from "../../../components/Modals/CheckTTL";
import Exchange from "../../../components/Exchange";
import ShowFareModal from "./ShowFareModal";
import { getChannelBadge, getStatusBadge } from "./bookingStatus";
import API_URL from "../../../redux2";
import { useDispatch } from "react-redux";
import Locals from "../../../utils/localFlights";
import {
  FZ,
  GALILEO,
  GDS,
  NDC,
  NDCManual,
  VISA,
  BAGGAGE,
  USER_ROLE_EMPLOYEE,
  USER_ROLE_FINANCE,
  USER_ROLE_SUPERAGENT,
  VOID_SC_AMOUNT,
  AIR_ARABIA,
  AMADEUS,
} from "../../../common/constants";
import { formatNumber } from "../../../utils/convertToNumber";
import { updateBooking } from "../../../redux2/booking/bookingSlice";
import {
  cancelIssuedTicket,
  retrieveTicket,
  retrieveTicketManual,
} from "../../../services/flight";
import { openModal } from "../../../redux2/modal/modalSlice";
import {
  NDCCancelOrderReq,
  // NDCExchangeReq,
  NDCRepriceReq,
  NDCReshopReq,
  NDCRetrieveReq,
} from "../../../components/NDC/NDCRequest/NDCRequest";
import {
  cancelNDCOrder,
  getNDCOrderRetrieve,
  repriceNDCOrder,
  reshopNDCOrder,
} from "../../../components/NDC/Services/NDCApi";
import { checkVoidTime } from "../../../services/helper";
import { getAirArabiaTicket } from "../../../components/AirArabia/Service/AirarabiaApi";
import IssueAirArabiaPayLater from "../../../components/AirArabia/Issue/IssuePayLater.airarabia";
import {
  cancelAmadeusTicket,
  retrieveAmadeusTicket,
  voidAmadeusTicket,
} from "../../../components/Amadeus/Services/AmadeusApi";
import IssueAmadeusPayLater from "../../../components/Amadeus/Issue/IssuePayLater.amadeus";

const BookingBody = ({
  bookings,
  currentPage,
  bookingPerPage,
  user,
  setBookingId,
  setLoading,
  setError,
  setShow,
  setVoidType,
  setBookingRequestModal,
  bookingRequestModal,
  setSelectedBooking,
  rateDifference,
  // utc,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const isSuper =
    user?.role === USER_ROLE_SUPERAGENT || user?.role === USER_ROLE_EMPLOYEE;

  const isManual = (booking) => {
    return (
      booking?.channel === GALILEO ||
      booking?.channel === FZ ||
      booking?.channel === NDCManual ||
      booking?.channel === VISA ||
      booking?.channel === BAGGAGE
    );
  };

  const cancelSegment = async (booking) => {
    if (booking?.channel === GDS) {
      setLoading(true);

      const resRetrieve = await retrieveTicket(
        booking?.flight?.retrievalPnr,
        setLoading,
      );

      if (!resRetrieve?.UniversalRecordRetrieveRsp?.UniversalRecord) {
        setError("Network Error, Please try again");
        setLoading(false);
        return;
      }

      const docs =
        resRetrieve?.UniversalRecordRetrieveRsp?.UniversalRecord?.AirReservation
          ?.DocumentInfo;

      const ticketInfo = Array.isArray(docs?.TicketInfo)
        ? docs?.TicketInfo
        : [docs?.TicketInfo];

      if (ticketInfo[0]?._attributes?.TicketingAgentSignOn) {
        toast.error("This ticket is already issued/Exchanged.");
        return;
      }

      const res = await axios.post(API_URL + "flight/cancel-segment", {
        PNR: booking?.flight?.retrievalPnr,
      });

      if (res.data?.Fault) {
        setError(res.data?.Fault?.faultstring?._text);
      } else {
        const data = {
          id: booking?._id,
          payment: "none",
          paymentStatus: "cancelled",
          status: "cancelled",
          serviceCharge: 0,
          systemFee: 0,
          PNR: "",
          RetrievalPnr: "",
        };
        dispatch(updateBooking(data));
        setTimeout(() => {
          navigate(0);
        }, 1000);
      }
      setLoading(false);
    } else {
      if (!booking?.flight?.PNR) return;

      const data = {
        PNR: booking?.flight?.PNR,
        carrier: booking?.flight?.carrier,
      };

      const retrieve = NDCRetrieveReq(data);

      const retrieveRes = await getNDCOrderRetrieve(
        retrieve,
        data?.carrier,
        setLoading,
      );

      if (retrieveRes?.Errors?.Error) {
        toast.error("Could not retrieve ticket");
        return;
      }

      if (retrieveRes?.Response?.TicketDocInfos?.TicketDocInfo) {
        toast.error(
          "This ticket is already issued/Exchanged. Please contact support.",
        );
        return;
      }

      const cancelOrder = NDCCancelOrderReq(data);

      const res = await cancelNDCOrder(cancelOrder, data, setLoading);

      if (res?.Errors?.Error) {
        setError(
          res?.Errors?.Error[0]?.value ||
            res?.Errors?.Error[0]?.ShortText ||
            "Couldn't Cancel Order",
        );
        return;
      }

      if (res?.Response) {
        navigate(0);
        return;
      }
    }
  };

  const retrievePnr = async (booking) => {
    const { flight, passengers, company } = booking;

    if (booking.channel === GDS) {
      if (!flight?.retrievalPnr) return;

      const res = await retrieveTicket(flight.retrievalPnr, setLoading);

      navigate(`/ticket/${flight?.retrievalPnr}`, {
        state: {
          ticketData: res?.UniversalRecordRetrieveRsp?.UniversalRecord,
          flightInfo: flight,
          passengerInfo: passengers,
          companyInfo: company,
        },
      });
    } else if (booking.channel === AIR_ARABIA) {
      const res = await getAirArabiaTicket(flight.providerPnr, setLoading);
      console.log(res);
      navigate(`/airarabia-ticket/${flight?.providerPnr}`, {
        state: {
          ticketData: res?.data,
          passengerInfo: passengers,
          companyInfo: company,
        },
      });
      return;
    } else if (booking.channel === AMADEUS) {
      console.log(flight);
      const res = await retrieveAmadeusTicket(flight, setLoading);

      navigate(`/amadeus-ticket/${flight?.providerPnr}`, {
        state: {
          ticketData: res?.data,
          passengerInfo: passengers,
          companyInfo: company,
        },
      });
    } else {
      const data = {
        PNR: flight?.PNR,
        carrier: flight?.carrier,
      };
      const retrieve = NDCRetrieveReq(data);

      const res = await getNDCOrderRetrieve(
        retrieve,
        flight.carrier,
        setLoading,
      );

      if (res?.Errors?.Error) {
        toast.error("Could not retrieve ticket");
        return;
      }

      navigate(`/ndc-ticket/${flight?.providerPnr}`, {
        state: {
          ticketData: res?.Response,
          passengerInfo: passengers,
          companyInfo: company,
        },
      });
    }
  };

  const issueNDCTicket = async (booking) => {
    const data = {
      PNR: booking?.flight?.PNR,
      carrier: booking?.flight?.carrier,
    };

    const retrieveReq = NDCRetrieveReq(data);
    const repriceReq = NDCRepriceReq(data);

    const [retrieve, reprice] = await Promise.all([
      await getNDCOrderRetrieve(
        retrieveReq,
        booking?.flight?.carrier,
        setLoading,
      ),
      await repriceNDCOrder(repriceReq, booking?.flight?.carrier, setLoading),
    ]);

    if (retrieve.Response && reprice?.response) {
      navigate(`/ndc-pay-later/${booking?.flight?.providerPnr}`, {
        state: {
          retrieve: retrieve?.Response,
          reprice: reprice?.response,
          booking: booking,
        },
      });
    }
  };

  const NDCTicketCancel = async (booking) => {
    const data = {
      PNR: booking?.flight?.PNR,
      carrier: booking?.flight?.carrier,
      orderItems: booking?.flight?.orderItems,
    };

    const reshopReq = NDCReshopReq(data);

    const res = await reshopNDCOrder(
      reshopReq,
      booking?.flight?.carrier,
      setLoading,
    );

    if (res?.Errors?.Error) {
      setError(
        res?.Errors?.Error[0]?.value ||
          res?.Errors?.Error[0]?.ShortText ||
          "Couldn't Reshop ",
      );
      return;
    }

    if (res?.Response) {
      navigate(`/ndc-cancel/${booking?.flight?.providerPnr}`, {
        state: {
          res: { ...res?.Response, CorrelationID: res?.CorrelationID },
          booking: booking,
        },
      });

      return;
    }
  };

  const NDCExchangeTicket = async (booking) => {
    const data = {
      PNR: booking?.flight?.PNR,
      carrier: booking?.flight?.carrier,
    };

    const retrieve = NDCRetrieveReq(data);

    const res = await getNDCOrderRetrieve(
      retrieve,
      booking?.flight.carrier,
      setLoading,
    );

    if (res?.Errors?.Error) {
      toast.error("Could not retrieve ticket");
      return;
    }

    navigate(`/ndc-exchange-search/${booking?.flight?.providerPnr}`, {
      state: {
        ticketData: res?.Response,
        booking: booking,
      },
    });
  };

  const AmadeusTicketVoid = async (booking) => {
    const data = {
      orderId: booking?.flight?.providerPnr,
      amaClientRef: booking?.flight?.orderItems?.[0],
    };

    try {
      const res = await voidAmadeusTicket(data, setLoading);

      if (res?.errors) {
        toast.error("Could not void ticket");
        return;
      }

      if (res?.Response) {
        toast.success("Ticket voided successfully");
      }
    } catch (error) {
      toast.error("Could not void ticket");
      return;
    }
    //  finally {
    //   setTimeout(() => {
    //     navigate(0);
    //   }, 1000);
    //   setLoading(false);
    // }
  };

  const confirmAmadeusVoid = async (booking) => {
    const isBefore4Hours = await checkVoidTime(booking?.flight);

    if (isBefore4Hours) {
      toast.error("Ticket cannot be voided 4 hours before departure");
      return;
    }

    const SC = isSuper ? 0 : (booking?.company?.voidFee ?? VOID_SC_AMOUNT);
    confirmAlert({
      customUI: ({ onClose }) => (
        <div className="text-center w-[500px] p-10 bg-white shadow-lg text-black">
          <h1 className="p-2 text-2xl font-bold text-red-500">
            Confirm Amadeus Ticket Void
          </h1>
          <p className="text-lg">
            Are you sure you want to void this Amadeus ticket?
          </p>
          {SC > 1 && (
            <p className="py-2 text-lg font-semibold text-main">
              Void Service Charge: {SC} ETB per passenger
            </p>
          )}
          <button
            onClick={onClose}
            className="w-40 border-1 cursor-pointer text-black text-lg m-2.5 p-2.5 border-black"
          >
            No
          </button>
          <button
            onClick={() => {
              AmadeusTicketVoid(booking);
              onClose();
            }}
            className="w-40 border-1 cursor-pointer text-red-500 text-lg m-2.5 p-2.5 border-red-500 font-bold"
          >
            Yes, Void it!
          </button>
        </div>
      ),
    });
  };

  const confirmAmadeusCancel = (booking) => {
    confirmAlert({
      customUI: ({ onClose }) => (
        <div className="text-center w-[500px] p-10 bg-white shadow-lg text-black">
          <h1 className="p-2 text-2xl font-bold text-red-500">
            Confirm Cancel Amadeus Booking
          </h1>
          <p className="text-lg">
            Are you sure you want to cancel this Amadeus booking?
          </p>
          <button
            onClick={onClose}
            className="w-40 border-1 cursor-pointer text-black text-lg m-2.5 p-2.5 border-black"
          >
            No
          </button>
          <button
            onClick={() => {
              AmadeusTicketCancel(booking);
              onClose();
            }}
            className="w-40 border-1 cursor-pointer text-red-500 text-lg m-2.5 p-2.5 border-red-500 font-bold"
          >
            Yes, Cancel it!
          </button>
        </div>
      ),
    });
  };

  const AmadeusTicketCancel = async (booking) => {
    const data = {
      orderId: booking?.flight?.providerPnr,
      amaClientRef: booking?.flight?.orderItems?.[0],
    };

    try {
      const res = await cancelAmadeusTicket(data, setLoading);

      if (res?.errors) {
        toast.error("Could not cancel ticket");
        return;
      }

      if (res?.Response) {
        toast.success("Ticket cancelled successfully");
      }
    } catch (error) {
      toast.error("Could not cancel ticket");
    }
    //  finally {
    //   setTimeout(() => {
    //     navigate(0);
    //   }, 700);
    //   setLoading(false);
    // }
  };

  // const reQuote = async (booking) => {
  //   const { flight } = booking;

  //   if (booking?.channel === GDS) {
  //     const res = await retrieveTicket(flight.retrievalPnr, setLoading);

  //     if (res?.UniversalRecordRetrieveRsp?.UniversalRecord) {
  //       const requestData = {
  //         TraceId: res?.UniversalRecordRetrieveRsp?._attributes?.TraceId,
  //         segments: [],
  //         passengers: [],
  //       };

  //       const { AirSegment, AirPricingInfo } =
  //         res.UniversalRecordRetrieveRsp.UniversalRecord.AirReservation;

  //       const addAttributesToArray = (source, targetArray) => {
  //         if (Array.isArray(source)) {
  //           source.forEach((item) =>
  //             targetArray.push({
  //               ...item._attributes,
  //               Provider: item?._attributes?.ProviderCode,
  //               FlightTime: item?._attributes?.TravelTime,
  //             })
  //           );
  //         } else if (source) {
  //           targetArray.push({
  //             ...source._attributes,
  //             Provider: source?._attributes?.ProviderCode,
  //             FlightTime: source?._attributes?.TravelTime,
  //           });
  //         }
  //       };

  //       addAttributesToArray(AirSegment, requestData.segments);
  //       addAttributesToArray(
  //         AirPricingInfo?.PassengerType,
  //         requestData.passengers
  //       );

  //       const pricingRes = await flightPricing(requestData, setLoading);

  //       const modifyReq = {
  //         RecordIdentifier: {
  //           UniversalLocatorCode: flight?.retrievalPnr,
  //           ProviderLocatorCode: flight?.providerPnr,
  //         },
  //         UniversalModifyCmd: {
  //           _attributes: {
  //             Key: "LJZ+WN/Y3BKADAAAAAAAAA==",
  //           },
  //           AirAdd: {
  //             _attributes: {
  //               ReservationLocatorCode: flight?.PNR,
  //             },
  //             AirPricingInfo: [],
  //             CreditCardAuth: {
  //               _attributes: {
  //                 Amount:
  //                   pricingRes.AirPriceRsp?.AirPriceResult
  //                     ?.AirPricingSolution?.[0]?._attributes?.TotalPrice ??
  //                   pricingRes.AirPriceRsp?.AirPriceResult?.AirPricingSolution
  //                     ?._attributes?.TotalPrice,
  //                 AuthCode: "",
  //                 AuthResultCode: "",
  //                 Number: "",
  //                 PaymentRef: "v3+Wl92GRSW5sHrcl3xkWw==",
  //               },
  //             },
  //           },
  //           UniversalAdd: {
  //             AccountingRemark: {
  //               _attributes: {
  //                 Key: "LJZ+WN/Y3BKADAAAAAAAAA==",
  //                 Category: "FT",
  //                 TypeInGds: "Other",
  //                 ProviderCode: "1G",
  //                 ProviderReservationInfoRef: "LJZ+WM/Y3BKACAAAAAAAAA==",
  //                 ElStat: "A",
  //               },
  //               RemarkData: "AP-5555123456789013/PK-45689",
  //             },
  //           },
  //         },
  //       };

  //       const PricingList =
  //         pricingRes.AirPriceRsp?.AirPriceResult?.AirPricingSolution;
  //       if (Array.isArray(PricingList)) {
  //         PricingList?.forEach((pricing) =>
  //           modifyReq.UniversalModifyCmd.AirAdd.AirPricingInfo.push(
  //             pricing.AirPricingInfo
  //           )
  //         );
  //       } else {
  //         modifyReq.UniversalModifyCmd.AirAdd.AirPricingInfo.push(
  //           PricingList.AirPricingInfo
  //         );
  //       }

  //       const modifyRes = await modifyPNR(modifyReq, setLoading);
  //     }
  //   }
  // };

  const confirmVoid = async (booking, type) => {
    const isBefore4Hours = await checkVoidTime(booking?.flight);

    if (isBefore4Hours && !isManual(booking)) {
      toast.error("Ticket cannot be voided 4 hours before departure");
      return;
    }

    const isSuper =
      [USER_ROLE_SUPERAGENT, USER_ROLE_EMPLOYEE].includes(user?.role) &&
      !booking?.company;

    const SC = isSuper ? 0 : (booking?.company?.voidFee ?? VOID_SC_AMOUNT);
    checkPassenger(booking)
      ? setShow(true)
      : confirmAlert({
          customUI: ({ onClose }) => {
            return (
              <div className="text-center w-[500px] p-10 bg-white shadow-lg text-black">
                <h1 className="p-2 text-2xl font-bold text-red-500">
                  Confirm Ticket Void{" "}
                  {type === "manual"
                    ? "(This action only refunds the ticket price to the agent's balance)"
                    : ""}
                </h1>
                <p className="text-lg">
                  Are you sure you want to void the ticket?
                </p>
                {SC > 1 && (
                  <p className="py-2 text-lg font-semibold text-main">
                    Void Service Charge: {SC} ETB per passenger
                  </p>
                )}
                <button
                  onClick={onClose}
                  className="w-40 border-1 cursor-pointer text-black text-lg m-2.5 p-2.5 border-black"
                >
                  No
                </button>
                <button
                  onClick={() => {
                    voidTicket(booking, SC, type);
                    onClose();
                  }}
                  className="w-40 border-1 cursor-pointer text-red-500 text-lg m-2.5 p-2.5 border-red-500 font-bold"
                >
                  Yes, {type === "manual" ? "Refund" : "Void"} it!
                </button>
              </div>
            );
          },
        });

    setSelectedBooking(booking);
    return;
  };

  const checkTicket = async (booking) => {
    const { flight, channel } = booking;

    if (isManual(booking)) {
      const ticketNumber = booking?.flight?.ticketNumber;
      if (!ticketNumber) {
        toast.error("No ticket number found");
        return;
      }

      const response = await retrieveTicketManual(ticketNumber, setLoading);

      if (response?.AirRetrieveDocumentRsp) {
        navigate(`/check-ticket/${flight?.retrievalPnr}`, {
          state: {
            ticketData: response?.AirRetrieveDocumentRsp?.ETR,
            type: "manual",
          },
        });
      } else {
        toast.error("Could not retrieve ticket");
        return;
      }
    }
    if (!flight?.retrievalPnr) return;

    if (channel === GDS) {
      const res = await retrieveTicket(flight.retrievalPnr, setLoading);

      navigate(`/check-ticket/${flight?.retrievalPnr}`, {
        state: {
          ticketData: res?.UniversalRecordRetrieveRsp?.UniversalRecord,
        },
      });
    } else if (channel === NDC) {
      const data = {
        PNR: flight?.PNR,
        carrier: flight?.carrier,
      };

      const retrieve = NDCRetrieveReq(data);

      const res = await getNDCOrderRetrieve(
        retrieve,
        flight.carrier,
        setLoading,
      );

      if (res?.Errors?.Error) {
        toast.error("Could not retrieve ticket");
        return;
      }

      navigate(`/ndc-check-status/${flight?.providerPnr}`, {
        state: {
          ticketData: res?.Response,
        },
      });
    } else if (channel === AIR_ARABIA) {
    } else if (channel === AMADEUS) {
      // const res = await retrieveAmadeusTicket(flight.retrievalPnr, setLoading);
      // navigate(`/check-ticket/${flight?.retrievalPnr}`, {
      //   state: {
      //     ticketData: res?.UniversalRecordRetrieveRsp?.UniversalRecord,
      //   },
      // });
    } else {
      toast.error("Could not retrieve ticket");
      return;
    }
  };

  const kachaOTP = async (booking, modalType) => {
    const kachaReq = {
      phone: booking?.company?.officeNumber,
      // principal: totalPrincipal.toString(),
      // phone: "251923130324",
      principal: "100",
      code: "80000030",
      pnr_number: booking.flight.PNR,
    };

    // const data = await KachaRequestLoan({ ...kachaReq, setLoading });
    setLoading(true);
    try {
      const { data } = await axios.post(
        API_URL + "booking/payment/kacha",
        kachaReq,
      );

      if (data?.initiate) {
        const modalData = {
          kacha: data?.initiate,
          id: booking?._id,
        };
        dispatch(openModal({ modalType, data: modalData }));
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }

    return;
  };

  const confirmCancel = async (booking, type) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className="text-center w-[500px] p-10 bg-white shadow-lg text-black">
            <h1 className="p-2 text-2xl font-bold text-red-500">
              Confirm Cancel Booking
            </h1>
            {type === "issue" && (
              <div className="flex flex-col mb-3 text-left">
                <h4 className="text-lg">
                  Message for cancellation of issued ticket booking
                </h4>
                <h4 className="text-base">
                  * You can use the CANCEL BOOKING button to:
                </h4>

                <div className="mx-3">
                  <p className="text-sm">
                    1. Cancel your booking before a no-show.
                  </p>
                  <p className="text-sm">
                    2. Prevent ADM charges after exchanging your ticket.
                  </p>
                </div>
              </div>
            )}
            <p className="text-lg">
              Are you sure you want to cancel the ticket?
            </p>
            <button
              onClick={onClose}
              className="w-40 border-1 cursor-pointer text-black text-lg m-2.5 p-2.5 border-black"
            >
              No
            </button>
            <button
              onClick={async () => {
                if (type === "issue") {
                  const data = {
                    PNR: booking?.flight?.retrievalPnr,
                    type: "issued",
                  };
                  onClose();
                  const res = await cancelIssuedTicket(
                    data,
                    setLoading,
                    setError,
                  );

                  if (
                    res?.UniversalRecordCancelRsp?.ProviderReservationStatus
                  ) {
                    toast.success("Ticket cancelled successfully");
                    setTimeout(() => {
                      navigate(0);
                    }, 700);
                  }
                  if (res?.Fault?.faultstring) {
                    toast.error(res?.Fault?.faultstring?._text);
                    return;
                  }
                } else {
                  cancelSegment(booking);
                }
              }}
              className="w-40 border-1 cursor-pointer text-red-500 text-lg m-2.5 p-2.5 border-red-500 font-bold"
            >
              Yes, Cancel it!
            </button>
          </div>
        );
      },
    });
  };

  const voidTicket = async (booking, SC, type) => {
    if (!booking) return;

    const data = {
      ProviderLocatorCode: booking?.flight?.providerPnr,
      documentNumbers: [],
      bookingId: booking?._id,
      company: booking?.company?._id,
      voidSC: SC,
    };

    for (let i = 0; i < booking?.flight?.ticketNumber?.length; i++) {
      data.documentNumbers.push({
        DocumentNumber: booking?.flight?.ticketNumber?.[i],
        DocumentType: "E-Ticket",
      });
    }

    setLoading(true);
    try {
      if (type === "manual") {
        if (isSuper && isManual(booking)) {
          await axios.post(API_URL + "flight/void-manual-ticket", data);

          toast.success("Ticket Voided Successfully");
        }
      } else {
        const res = await axios.post(API_URL + "flight/void-ticket", data);

        if (
          res.data?.AirVoidDocumentRsp?.VoidResultInfo?.[0]?.FailureRemark
            ?._text ||
          res.data?.AirVoidDocumentRsp?.VoidResultInfo?.FailureRemark?._text
        ) {
          setError(
            res.data?.AirVoidDocumentRsp?.VoidResultInfo?.FailureRemark?._text,
          );
          return;
        }

        if (
          res.data.AirVoidDocumentRsp?.VoidResultInfo?.[0]?._attributes
            ?.ResultType === "Success" ||
          res.data.AirVoidDocumentRsp?.VoidResultInfo?._attributes
            ?.ResultType === "Success"
        ) {
          await axios.post(API_URL + "flight/cancel-segment", {
            PNR: booking?.flight?.retrievalPnr,
          });
          toast.success("Ticket Voided Successfully");
        }
      }
    } catch (error) {
      console.log(error);
    } finally {
      setTimeout(() => {
        navigate(0);
      }, 1000);
      setLoading(false);
    }
  };

  const handleLink = (booking) => {
    let docs = booking?.documents;

    docs.forEach((link) => {
      window.open(link, "_blank");
    });

    docs?.forEach((doc, index) => {
      fetch(doc)
        .then((response) => response.blob())
        .then((blob) => {
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.style.display = "none";
          a.href = url;
          // a.download = fileName.doc.split(".").pop();
          a.download =
            `${booking?.flight?.ticketNumber[index] || ""}-${
              booking?.passengers[index]?.firstName +
              " " +
              booking?.passengers[index]?.lastName
            }` +
            "." +
            doc.split(".").pop();
          document.body.appendChild(a);
          a.click();
          window.URL.revokeObjectURL(url);
          document.body.removeChild(a);
        })
        .catch((error) => console.error("Download error:", error));
    });
  };

  function customDate(date) {
    let d = date?.split("T")?.[0];
    return moment(d).format("MMM DD, YYYY");
  }

  function checkBeforeMidnight(booking) {
    const issueDate = new Date(booking?.createdAt);
    const currentDate = new Date(); // Current date and time

    currentDate.setHours(0, 0, 0, 0);

    const isBeforeMidnight = issueDate >= currentDate;
    return isBeforeMidnight;
  }

  function checkPassenger(booking) {
    let isPassenger = true;
    if (booking?.passengers?.length === 1) {
      return false;
    }
    if (booking?.currency === "USD") {
      return false;
    }
    isPassenger = booking?.passengers?.every(
      (passenger) => passenger?.type === "ADT" || passenger?.type === "LBR",
    );

    return isPassenger;
  }

  function reBook(booking) {
    const { flight, passengers } = booking;

    const isLocal =
      Locals.includes(flight?.origin) && Locals.includes(flight?.destination);

    const tripTypeMap = {
      "One Way": "oneWay",
      "Round Trip": "roundTrip",
      "Multi City": "multiCity",
    };
    const tripType = tripTypeMap[flight?.flightType] || "oneWay";
    const cabinClass = booking?.channel === GDS ? flight?.cabinClass : "";

    let passengerCount = {
      ADT: 0,
      CNN: 0,
      INF: 0,
      LBR: 0,
    };

    passengers.forEach((passenger) => {
      passengerCount[passenger.type] += 1;
    });

    let queryURl = `/?origin=${flight.origin}&destination=${
      flight.destination
    }&tripType=${tripType}&cabinClass=${cabinClass}&adults=${
      passengerCount?.ADT
    }&labors=${passengerCount.LBR}&children=${passengerCount.CNN}&infants=${
      passengerCount.INF
    }&startDate=${
      flight?.routes?.[0]?.departureTime[0]?.split("T")?.[0]
    }&endDate=${
      flight?.routes?.[1]?.departureTime[0]?.split("T")?.[0]
    }&isLocal=${isLocal}&_id=${booking?._id}`;

    navigate(queryURl, {
      state: {
        multiCityParams: flight.originalPath,
      },
    });
  }

  function calculateOriginalPrice(booking) {
    let originalPrice = 0;
    booking.passengers?.forEach((flight) => {
      originalPrice += flight?.price;
    });

    originalPrice =
      booking?.currency === "USD" && booking?.company
        ? (originalPrice * rateDifference).toFixed(2)
        : originalPrice;

    let charge =
      booking?.currency === "USD"
        ? booking?.USDServiceCharge || 0
        : (booking?.serviceCharge || 0) + (booking?.NDCServiceCharge || 0);

    let result =
      parseFloat(originalPrice) + charge + booking?.returnedServiceCharge || 0;
    return formatNumber(result.toFixed(2));
  }

  return (
    <>
      {bookings?.length === 0 ? (
        <tr>
          <td colSpan={11}>
            <Typography variant="h5">No Booking Found</Typography>
          </td>
        </tr>
      ) : (
        bookings?.map((booking, index) => (
          <tr role="row" className="odd" key={index}>
            <td>
              <div className="relative">
                <p>{index + 1 + (currentPage - 1) * bookingPerPage} </p>
                {getChannelBadge(booking)}
              </div>
            </td>
            <td className="py-2 text-right">
              <Dropdown className="dropdown text-sans-serif">
                <Dropdown.Toggle
                  // id="dropdown"
                  variant=""
                  className="text-primary hover:bg-main-200 i-false tp-btn-light sharp"
                  type="button"
                  id="order-dropdown-0"
                  data-toggle="dropdown"
                  data-boundary="viewport"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <span>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      xmlnsXlink="http://www.w3.org/1999/xlink"
                      width="18px"
                      height="18px"
                      viewBox="0 0 24 24"
                      version="1.1"
                    >
                      <g
                        stroke="none"
                        strokeWidth={1}
                        fill="none"
                        fillRule="evenodd"
                      >
                        <rect x={0} y={0} width={24} height={24} />
                        <circle fill="#000000" cx={5} cy={12} r={2} />
                        <circle fill="#000000" cx={12} cy={12} r={2} />
                        <circle fill="#000000" cx={19} cy={12} r={2} />
                      </g>
                    </svg>
                  </span>
                </Dropdown.Toggle>

                {user.role !== USER_ROLE_FINANCE && (
                  <Dropdown.Menu
                    className="py-0 border dropdown-menu dropdown-menu-right"
                    aria-labelledby="order-dropdown-0"
                  >
                    {booking?.status === "confirmed" && (
                      <>
                        <div>
                          <button
                            className="dropdown-item"
                            onClick={() => retrievePnr(booking)}
                          >
                            Get Ticket
                          </button>
                        </div>
                        {/* <div className="">
                          <button
                            className="dropdown-item"
                            onClick={() => NDCReshop(booking)}
                          >
                            Reshop
                          </button>
                        </div> */}
                        {checkBeforeMidnight(booking) && (
                          <>
                            {(booking?.channel === GDS ||
                              booking?.channel === GALILEO) && (
                              <div className="">
                                <button
                                  className="dropdown-item"
                                  onClick={() => confirmVoid(booking)}
                                >
                                  Void Ticket
                                </button>
                              </div>
                            )}
                            {isSuper && isManual(booking) && (
                              <div className="">
                                <button
                                  className="dropdown-item"
                                  onClick={() => {
                                    setVoidType("manual");
                                    confirmVoid(booking, "manual");
                                  }}
                                >
                                  Manual Void Ticket
                                </button>
                              </div>
                            )}
                          </>
                        )}
                        {booking?.channel === GDS && (
                          <div className="">
                            <button
                              className="dropdown-item"
                              onClick={() => confirmCancel(booking, "issue")}
                            >
                              Cancel Booking
                            </button>
                          </div>
                        )}
                        {booking?.channel === NDC && (
                          <div className="">
                            <button
                              className="dropdown-item"
                              onClick={() => NDCTicketCancel(booking)}
                            >
                              Order Cancel(Void/Refund)
                            </button>
                          </div>
                        )}
                        {/* {booking?.channel === AMADEUS && (
                          <div className="">
                            <button
                              className="dropdown-item"
                              onClick={() => confirmAmadeusVoid(booking)}
                            >
                              Void Ticket
                            </button>
                          </div>
                        )} */}
                        {isSuper && booking?.channel === GDS && (
                          <Exchange selectedBooking={booking} />
                        )}

                        {isSuper && booking?.channel === NDC && (
                          <div className="">
                            <button
                              className="dropdown-item"
                              onClick={() => NDCExchangeTicket(booking)}
                            >
                              Exchange Ticket
                            </button>
                          </div>
                        )}

                        {booking?.fareRule && (
                          <ShowFareModal rule={booking?.fareRule} />
                        )}
                        {/* <MiniFareRuleModal
                        setLoading={setLoading}
                        loading={loading}
                        pnr={booking?.flight?.retrievalPnr}
                      /> */}
                      </>
                    )}

                    {(booking?.status === "issued-cancelled" ||
                      booking?.status === "exchange-cancelled") && (
                      <>
                        {checkBeforeMidnight(booking) &&
                          booking?.channel === GDS && (
                            <div className="">
                              <button
                                className="dropdown-item"
                                onClick={() => confirmVoid(booking)}
                              >
                                Void Ticket
                              </button>
                            </div>
                          )}
                      </>
                    )}

                    {booking?.status === "exchanged" && (
                      <div>
                        <button
                          className="dropdown-item"
                          onClick={() => retrievePnr(booking)}
                        >
                          Get Ticket
                        </button>
                        {booking?.channel === GDS && (
                          <div className="">
                            <button
                              className="dropdown-item"
                              onClick={() => confirmCancel(booking, "issue")}
                            >
                              Cancel Booking
                            </button>
                          </div>
                        )}
                        {/* {isSuper && booking?.channel === NDC && (
                          <div className="">
                            <button
                              className="dropdown-item"
                              onClick={() => NDCExchangeTicket(booking)}
                            >
                              Exchange Ticket
                            </button>
                          </div>
                        )} */}
                      </div>
                    )}
                    {(booking?.status === "pending" ||
                      booking?.status === "restricted") && (
                      <>
                        {booking?.channel === GDS ? (
                          <IssueTicket
                            user={user}
                            booking={booking}
                            currency={booking?.currency}
                            // utc={utc}
                          />
                        ) : booking?.channel === NDC ? (
                          <div className="">
                            <button
                              className="dropdown-item"
                              onClick={() => issueNDCTicket(booking)}
                            >
                              Issue Ticket
                            </button>
                          </div>
                        ) : booking?.channel === AMADEUS ? (
                          <IssueAmadeusPayLater
                            user={user}
                            booking={booking}
                            currency={booking?.currency}
                          />
                        ) : (
                          <IssueAirArabiaPayLater
                            user={user}
                            booking={booking}
                            currency={booking?.currency}
                          />
                        )}
                        {/* </button> */}
                        <div className="">
                          <button
                            className="dropdown-item"
                            onClick={() => retrievePnr(booking)}
                          >
                            View Booking
                          </button>
                        </div>

                        <div className="">
                          <button
                            className="dropdown-item"
                            onClick={() =>
                              booking?.channel === AMADEUS
                                ? confirmAmadeusCancel(booking)
                                : confirmCancel(booking)
                            }
                          >
                            Cancel Booking
                          </button>
                        </div>

                        {booking?.channel === GDS && (
                          <>
                            {/* <div className="">
                              <button
                                className="dropdown-item"
                                onClick={() => reQuote(booking)}
                              >
                                Re-quote
                              </button>
                            </div> */}
                            <div className="dropdown-item">
                              <CheckTTL booking={booking} />
                            </div>
                          </>
                        )}
                      </>
                    )}
                    {booking?.paymentStatus === "unpaidKachaCredit" && (
                      <button
                        className="cursor-pointer dropdown-item"
                        onClick={() => kachaOTP(booking, "Kacha")}
                      >
                        Re-enter Kacha OTP
                      </button>
                    )}
                    <button
                      className="cursor-pointer dropdown-item"
                      onClick={() => reBook(booking)}
                    >
                      Re-book Flight
                    </button>
                    <div className="dropdown-item">
                      <BookingDetail booking={booking} />
                    </div>
                    <button
                      className="cursor-pointer dropdown-item"
                      onClick={() => checkTicket(booking)}
                    >
                      Check Status
                    </button>
                    {booking?.status === "bookingRequested" && (
                      <Button
                        className="dropdown-item hover:bg-main-800 border-main-100"
                        onClick={() => {
                          setBookingRequestModal(!bookingRequestModal);
                          setBookingId(booking?._id);
                        }}
                      >
                        Change Booking Request Status
                      </Button>
                    )}
                    {(booking?.status === "confirmed" ||
                      booking?.status === "exchanged" ||
                      booking?.status === "issued-cancelled" ||
                      booking?.status === "exchange-cancelled") &&
                      !checkBeforeMidnight(booking) && (
                        <div className="py-2">
                          <Link
                            to={`/send-request/${booking?._id}`}
                            className="dropdown-item"
                          >
                            Send Request
                          </Link>
                        </div>
                      )}
                  </Dropdown.Menu>
                )}
              </Dropdown>
            </td>
            <td className="py-2">
              {booking?.paymentStatus === "unpaidKachaCredit"
                ? getStatusBadge(booking?.paymentStatus, true)
                : getStatusBadge(booking.status)}
            </td>

            <td>
              <div className="media-bx">
                <div>
                  <h4>
                    <div className="text-sm font-semibold text-black capitalize">
                      {booking?.passengers?.map((passenger, index) => {
                        return (
                          <Fragment key={passenger._id}>
                            <p key={passenger._id}>
                              {passenger?.firstName} {passenger?.lastName}
                            </p>
                            {index === 0 && (
                              <span className="text-xs text-gray-400">
                                +{passenger?.phoneNumber}
                              </span>
                            )}
                          </Fragment>
                        );
                      })}
                    </div>
                  </h4>
                </div>
              </div>
            </td>
            <td>
              <div className="text-main">
                {booking?.flight?.ticketNumber.map((ticket, index) => {
                  return booking?.passengers?.[index]?.status !== "pending" &&
                    booking?.passengers?.[index]?.status !== undefined &&
                    booking.status === "confirmed" ? (
                    <p key={index} className="text-indigo-500">
                      {ticket}{" "}
                      <span className="text-xs">
                        {booking?.passengers?.[index]?.status}
                      </span>
                    </p>
                  ) : (
                    <p key={index}>{ticket}</p>
                  );
                }) || ""}{" "}
                {/* {booking?.passengers?.map((passenger, index) => {
                  return (
                    <Fragment key={passenger._id}>
                      <p key={passenger._id}>{passenger?.ticketNumber}</p>
                    </Fragment>
                  );
                })} */}
              </div>
              {/* <p className="text-main">#ET-631c3e1d29</p> */}
            </td>
            <td>
              <div className="text-main">
                {booking?.flight?.exTicketNumber.map((ticket, index) => {
                  return <p key={index}>{ticket}</p>;
                }) || ""}{" "}
              </div>
              {/* <p className="text-main">#ET-631c3e1d29</p> */}
            </td>
            <td>
              <div>
                <h5>
                  {booking?.status === "confirmed"
                    ? moment(booking?.updatedAt).format("MMM DD, YYYY")
                    : moment(booking?.createdAt).format("MMM DD, YYYY")}
                </h5>
                <span className="fs-14">
                  {booking?.status === "confirmed"
                    ? moment(booking?.updatedAt).format("hh:mm A")
                    : moment(booking?.createdAt).format("hh:mm A")}
                </span>
              </div>
            </td>
            <td>
              <p className="text-center">{booking?.flight?.carrier}</p>
            </td>
            <td>
              <Link
                className="capitalize"
                to={`/agent-billing/${booking?.company?._id}`}
              >
                {booking?.company?.name || "Sterling Tour"}
              </Link>
            </td>
            <td>
              <p className="capitalize">
                {booking?.agent?.firstName + " " + booking?.agent?.lastName}
              </p>
            </td>
            <td>
              <p>{booking?.corporateName}</p>
            </td>
            <td>
              <p className="text-green-600">{booking?.payment}</p>
            </td>
            <td>
              <p>
                {/* {booking?.flight?.origin} - {booking?.flight?.destination} */}
                {/* {booking?.flight?.isRoundTrip ? "Round Trip" : "One Way"} */}
                {booking?.flight?.flightType}
              </p>
            </td>
            <td>
              {booking?.flight?.routes?.length > 0 ? (
                booking?.flight?.routes?.map((route, index) => (
                  <p className="w-36" key={index}>
                    {route?.flights.map((flight, index) => {
                      const separator =
                        index === route?.flights.length - 1 ? "" : "-";
                      return flight + separator;
                    })}
                  </p>
                ))
              ) : (
                <p>
                  {booking?.flight?.origin + "-" + booking?.flight?.destination}
                </p>
              )}
              {/* <p>
                  {booking?.flight?.routes?.[1]?.flights.map(
                    (flight, index) => {
                      const separator =
                        index ===
                        booking?.flight?.routes?.[0]?.flights.length - 1
                          ? ""
                          : "-";
                      return flight + separator;
                    }
                  )}
                </p> */}
            </td>
            <td>
              <div>
                {booking?.flight?.flightType !== "Multi City"
                  ? booking?.flight?.routes?.map((flight, index) => (
                      <Fragment key={index}>
                        <h5>{customDate(flight?.departureTime?.[0])}</h5>
                        <span className="fs-14">
                          {customTime(flight?.departureTime?.[0])}
                        </span>
                      </Fragment>
                    ))
                  : booking?.flight?.routes?.map((flight, index) => (
                      <Fragment key={index}>
                        {flight?.departureTime?.map((dept) => (
                          <Fragment>
                            <h5>{customDate(dept)}</h5>
                            <span className="fs-14">{customTime(dept)}</span>
                          </Fragment>
                        ))}
                      </Fragment>
                    ))}
              </div>
            </td>
            <td>
              {booking?.flight?.flightType !== "Multi City"
                ? booking?.flight?.routes?.map((flight, index) => (
                    <Fragment key={index}>
                      <h5>
                        {customDate(
                          flight?.arrivalTime?.[
                            flight?.arrivalTime?.length - 1
                          ],
                        )}
                      </h5>
                      <span className="fs-14">
                        {customTime(
                          flight?.arrivalTime?.[
                            flight?.arrivalTime?.length - 1
                          ],
                        )}
                      </span>
                    </Fragment>
                  ))
                : booking?.flight?.routes?.map((flight, index) => (
                    <Fragment key={index}>
                      {flight?.arrivalTime?.map((arrive) => (
                        <Fragment>
                          <h5>{customDate(arrive)}</h5>
                          <span className="fs-14">{customTime(arrive)}</span>
                        </Fragment>
                      ))}
                    </Fragment>
                  ))}
            </td>
            <td>
              <p>
                {formatNumber(booking?.totalPrice.toFixed(2))} <br />
                {/* {booking?.flight?.price + booking?.serviceCharge || 0} */}
                <span className="mx-1 text-blue-700">ETB</span>
              </p>
            </td>
            <td>
              <p>
                {booking?.type !== "exchange" && booking?.type !== "refund"
                  ? calculateOriginalPrice(booking)
                  : "-"}{" "}
                <br />
                <span className="text-blue-700">
                  {booking?.currency || "ETB"}
                </span>
              </p>
            </td>
            <td>
              <p>
                {formatNumber(booking?.refundedAmount?.toFixed(2) || 0)}{" "}
                <span className="mx-1 text-blue-700">ETB</span>
              </p>
            </td>
            {
              // user?.role === USER_ROLE_SUPERAGENT &&
              booking?.documents.length > 0 ? (
                <td>
                  <button
                    onClick={() => handleLink(booking)}
                    key={index}
                    className="p-1 text-black bg-white rounded-md transition duration-300 ease-in-out transform outline hover:bg-gray-100 hover:-translate-y-1 hover:scale-110 hover:shadow-xl focus:outline-none"
                  >
                    View {booking?.documents.length} Documents
                  </button>
                </td>
              ) : (
                <td></td>
              )
            }
            <td>
              <p className="text-center">
                {/* {booking?.flight?.retrievalPnr} */}
                {booking?.channel === AMADEUS
                  ? booking?.flight?.PNR
                  : (booking?.flight?.providerPnr ?? booking?.flight?.PNR)}
              </p>
            </td>
            <td>
              <p className="text-center">{booking?.paymentReference}</p>
            </td>
            <td>
              <p className="text-center">{booking?.channel}</p>
            </td>
            <td>
              <p className="text-center">{booking?.paymentStatus}</p>
              <p className="text-center text-black">{booking?.reference}</p>
            </td>
          </tr>
        ))
      )}

      {/* <KachaCreditOTP otp={otp} setOtp={setOtp} /> */}
    </>
  );
};

export default BookingBody;
